/** Entrada de carpeta local lista para validar y encolar en ingesta. */
export interface IngestFolderFileEntry {
  file: File;
  relativePath: string;
}

export function isIngestDirectoryPickerAvailable(): boolean {
  return typeof window !== 'undefined' && 'showDirectoryPicker' in window;
}

function getDirectoryPickerWindow(): IngestDirectoryPickerWindow | null {
  if (!isIngestDirectoryPickerAvailable()) {
    return null;
  }
  return window as unknown as IngestDirectoryPickerWindow;
}

async function walkDirectoryHandle(
  dirHandle: IngestFileSystemDirectoryHandle,
  prefix: string,
): Promise<IngestFolderFileEntry[]> {
  const results: IngestFolderFileEntry[] = [];

  for await (const handle of dirHandle.values()) {
    const name = handle.name;
    const path = prefix ? `${prefix}/${name}` : name;
    if (handle.kind === 'file') {
      const file = await (handle as IngestFileSystemFileHandle).getFile();
      results.push({
        file,
        relativePath: path.replace(/\\/g, '/').replace(/^\/+/, ''),
      });
      continue;
    }
    results.push(
      ...(await walkDirectoryHandle(
        handle as IngestFileSystemDirectoryHandle,
        path,
      )),
    );
  }

  return results;
}

/**
 * Selector moderno de carpetas (File System Access API).
 * Evita el aviso nativo «¿Quieres subir N archivos a este sitio web?» del input webkitdirectory.
 */
export async function pickIngestFolderFiles(): Promise<IngestFolderFileEntry[] | null> {
  const pickerWindow = getDirectoryPickerWindow();
  if (!pickerWindow) {
    return null;
  }

  try {
    const dirHandle = await pickerWindow.showDirectoryPicker({ mode: 'read' });
    return await walkDirectoryHandle(dirHandle, dirHandle.name);
  } catch (err) {
    if (err instanceof DOMException && err.name === 'AbortError') {
      return [];
    }
    throw err;
  }
}
